import styled from 'styled-components';

export const AdditionalProductsTitle = styled.h4`
  margin-bottom: 8px;
  margin-top: 0;
  font-size: 20px;
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.secondary};
  line-height: 32px;
  color: ${({ theme }) => theme.palette.common.TEXTS};
`;
